export default __webpack_public_path__ + "static/media/avatar_10.65302636.png";